export const privacyPolicy = {
  title: "QWiK 개인정보처리방침",
  lastUpdated: "2025-11-21",
  effectiveDate: "2025-11-21",
  sections: [
    {
      id: "purpose",
      title: "1. 개인정보의 처리목적",
      content: `QWiK는 다음의 목적을 위하여 개인정보를 처리합니다:
  • 회원 가입 및 관리
  • GitHub 레포지토리 배포 서비스 제공
  • 고객 지원 및 문의사항 처리
  • 서비스 개선을 위한 통계 분석`,
      isOpen: false,
    },
    {
      id: "retention",
      title: "2. 개인정보의 처리 및 보유기간",
      content: `  • 보유기간: 회원 탈퇴 시까지
  • 탈퇴 즉시 지체없이 파기 (단, 관계법령에 의한 정보보유 사유 제외)`,
      isOpen: false,
    },
    {
      id: "collection",
      title: "3. 수집하는 개인정보 항목",
      content: `  (필수항목)
  • GitHub 사용자 ID
  • GitHub 사용자명(Username)  
  • 이메일 주소
  • 서비스 이용 기록`,
      isOpen: false,
    },
    {
      id: "method",
      title: "4. 개인정보의 수집방법",
      content: `  • GitHub OAuth 인증을 통한 자동 수집
  • 이용자에게 직접 입력 받아 수집 (트래픽 알림용 이메일 등)`,
      isOpen: false,
    },
    {
      id: "thirdParty",
      title: "5. 개인정보의 제3자 제공",
      content: `  회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.
  단, 다음의 경우는 예외로 합니다:
  
  • 이용자가 사전에 동의한 경우
  • 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`,
      isOpen: false,
    },
    {
      id: "outsourcing",
      title: "6. 개인정보처리 위탁",
      content: `  • 위탁받는 자: Amazon Web Services (AWS)
  • 위탁하는 업무의 내용: 서버 호스팅 및 데이터 저장`,
      isOpen: false,
    },
    {
      id: "rights",
      title: "7. 정보주체와 법정대리인의 권리·의무 및 그 행사방법",
      content: `  이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다:
  
  • 개인정보 열람요구권
  • 개인정보 정정·삭제요구권  
  • 개인정보 처리정지 요구권
  • 손해배상청구권`,
      isOpen: false,
    },
    {
      id: "contact",
      title: "8. 개인정보 보호책임자",
      content: `  • 개인정보 보호책임자: QWiK 운영팀
  • 연락처: privacy@qwik.com`,
      isOpen: false,
    },
    {
      id: "changes",
      title: "9. 개인정보 처리방침 변경",
      content: `  본 방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
  
  시행일자: 2025년 11월 21일`,
      isOpen: false,
    },
  ],
};

export default privacyPolicy;
